module.exports = __webpack_public_path__ + "static/media/fold1.e52ff49a.jpg";